module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('h1', {
    staticClass: "panel-title",
    slot: "heading"
  }, [_vm._v("\n      Password Reset\n    ")]), _vm._v(" "), (!_vm.emailSent) ? _c('div', {
    slot: "body"
  }, [_c('p', [_vm._v("\n        Please confirm you wish to reset your password by clicking the button below."), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', [_vm._v("\n        This will send a password reset link to your registered email address (" + _vm._s(_vm.email) + ")."), _c('br')]), _vm._v(" "), (_vm.errmsg !== '') ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('br'), _vm._v("\n        ERROR: " + _vm._s(_vm.errmsg)), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.doingSomething,
      "hhref": "",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.sendemail()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "padding-left"
  }, [_vm._v("Send Reset Password EMail")])])])]) : _vm._e(), _vm._v(" "), (_vm.emailSent) ? _c('div', {
    slot: "body"
  }, [_c('p', [_vm._v("\n        A password reset link has been sent to your registered email address (" + _vm._s(_vm.email) + ")."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        Please click the link in the email to reset your password.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n         \n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    slot: "footer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73709354"}!./src/app/pages/user/resetpw/index.html
// module id = 230
// module chunks = 1